import React, { useState } from "react";
import Template from "../components/Template";

const applicationEndpoint = (() => {
  const publicUrl = "https://dailyfitzone.com/api/apply-performance-leadership.php";

  return publicUrl;
 
})();

function ApplyPerformanceLeadership() {
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatusMessage("");
    setStatusType("");

    const formData = new FormData(event.target);

    try {
      const response = await fetch(applicationEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to submit your application.");
      }

      setStatusMessage(data.message || "Your application was submitted successfully.");
      setStatusType("success");
      event.target.reset();
    } catch (error) {
      setStatusMessage(error.message || "Something went wrong. Please try again later.");
      setStatusType("error");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Template>
      {/* <BreadCrumb
        pageName="Apply for Performance Leadership"
        // breadCrumbTitle="Apply for Performance Leadership"
        // breadCrumbSubTitle="Executive-grade performance development for individuals ready to elevate focus, execution, and decision quality."
      /> */}

      {/* Contact Us Start */}
       
      <div className="section-lgx pb-0"></div>
      <section className="section-lgx">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <form
                className="contact-form"
                method="post"
                id="contact-form"
                action={applicationEndpoint}
                onSubmit={handleSubmit}
              >
                <h4>Personal Information</h4>

                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Full Name *"
                        name="name"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address *"
                        name="email"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <select
                        className="form-control"
                        name="country"
                        required
                        defaultValue=""
                        style={{ background: "#0C0920" }}
                      >
                        <option value="" disabled>
                          Country / Region *
                        </option>
                        <option style={{ color: "white" }} value="India">
                          India
                        </option>
                        <option style={{ color: "white" }} value="USA">
                          United States
                        </option>
                        <option style={{ color: "white" }} value="UK">
                          United Kingdom
                        </option>
                        <option style={{ color: "white" }} value="Canada">
                          Canada
                        </option>
                        <option style={{ color: "white" }} value="Australia">
                          Australia
                        </option>
                      </select>
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Current Role / Title *"
                        name="role-title"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Organization / Company"
                        name="organization"
                      />
                    </p>
                  </div>
                </div>

                <h4>Leadership Context</h4>

                <div className="row">
                  {/* Primary Leadership Responsibility */}
                  <div className="col-md-12">
                    <p>
                      <strong>Primary Leadership Responsibility *</strong>
                    </p>

                    <p>
                      <label>
                        <input
                          type="radio"
                          style={{ display: "inline-block", width: "auto" }}
                          name="leadership_responsibility"
                          value="Leading people"
                          required
                        />{" "}
                        Leading people
                      </label>
                    </p>
                    <p>
                      <label>
                        <input
                          type="radio"
                          name="leadership_responsibility"
                          value="Leading projects or programs"
                        />{" "}
                        Leading projects or programs
                      </label>
                    </p>
                    <p>
                      <label>
                        <input
                          type="radio"
                          name="leadership_responsibility"
                          value="Leading strategy / decisions"
                        />{" "}
                        Leading strategy / decisions
                      </label>
                    </p>
                    <p>
                      <label>
                        <input
                          type="radio"
                          name="leadership_responsibility"
                          value="Founder / business owner"
                        />{" "}
                        Founder / business owner
                      </label>
                    </p>
                    <p>
                      <label>
                        <input
                          type="radio"
                          name="leadership_responsibility"
                          value="Combination"
                        />{" "}
                        Combination of the above
                      </label>
                    </p>
                  </div>

                  {/* Team Size You Influence */}
                  <div className="col-md-6">
                    <p>
                      <select
                        className="form-control"
                        name="team_size"
                        required
                        defaultValue=""
                        style={{color: "black", background: 'white'}}
                      >
                        <option value="" disabled>
                          Team Size You Influence *
                        </option>
                        <option value="Individual / project-based">
                          Individual / project-based
                        </option>
                        <option value="1-5">1–5</option>
                        <option value="6-15">6–15</option>
                        <option value="16-50">16–50</option>
                        <option value="50+">50+</option>
                      </select>
                    </p>
                  </div>
                </div>

                <h4>Readiness Confirmation</h4>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <strong>Please confirm the following:</strong>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="readiness_reflection"
                          required
                        />{" "}
                        I am willing to reflect honestly on my leadership
                        patterns
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="readiness_change"
                          required
                        />{" "}
                        I am open to changing how I lead, not just learning
                        ideas
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="readiness_commitment"
                          required
                        />{" "}
                        I can commit 90–120 minutes per week
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="readiness_responsibility"
                          required
                        />{" "}
                        I take responsibility for my leadership growth
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="readiness_sustainable"
                          required
                        />{" "}
                        I am seeking sustainable performance, not quick
                        motivation
                      </label>
                    </p>
                  </div>
                </div>

                <h4>Assessment Acknowledgement</h4>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="assessment_reviewed"
                          required
                        />{" "}
                        I have reviewed my BRILLIANCE™ Assessment Letter
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="assessment_understanding"
                          required
                        />{" "}
                        I understand my leadership strengths and development
                        areas
                      </label>
                    </p>

                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="assessment_awareness"
                          required
                        />{" "}
                        I am enrolling with awareness of my current leadership
                        state
                      </label>
                    </p>
                  </div>
                </div>

                <h4>Program Selection</h4>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <strong>Choose Your Program *</strong>
                    </p>

                    <p>
                      <label>
                        <input
                          type="radio"
                          name="program_selection"
                          value="6-week"
                          required
                        />{" "}
                        BRILLIANCE™ 6-Week Intensive
                      </label>
                      <br />
                      Focused reset for clarity, resilience, and momentum
                    </p>

                    <p>
                      <label>
                        <input
                          type="radio"
                          name="program_selection"
                          value="12-week"
                        />{" "}
                        BRILLIANCE™ 12-Week Executive Program
                      </label>
                      <br />
                      Deep leadership mastery and long term impact
                    </p>

                    <p>
                      <label>
                        <input
                          type="radio"
                          name="program_selection"
                          value="corporate"
                        />{" "}
                        Corporate / Organization Sponsored Cohort
                      </label>
                    </p>
                  </div>
                </div>

                <h4>Leadership Intent</h4>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <textarea
                        className="form-control"
                        name="leadership_intent"
                        placeholder="What would meaningful progress in your leadership look like over the next 6–12 months?"
                        rows="5"
                        required
                        minLength={50}
                      ></textarea>
                    </p>
                  </div>
                </div>

                <h4>Final Commitment</h4>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <label>
                        <input
                          type="checkbox"
                          name="final_commitment"
                          required
                        />{" "}
                        I understand BRILLIANCE™ is a leadership development
                        program and I commit to active participation and
                        application.
                      </label>
                    </p>
                  </div>
                </div>

                <div className="pbmit-submit-btn-container">
                  <button
                    type="submit"
                    className="pbmit-btn pbmit-btn-white pbmit-submit-btn"
                    disabled={isSubmitting}
                  >
                    <i
                      className={`form-btn-loader fa fa-circle-o-notch fa-spin fa-fw margin-bottom ${
                        isSubmitting ? "" : "d-none"
                      }`}
                    ></i>
                    <span className="button-text">
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </span>
                  </button>
                </div>
                <div className={`col-md-12 col-lg-12 message-status ${statusType}`}>
                  {statusMessage}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Us End */}
    </Template>
  );
}

export default ApplyPerformanceLeadership;
